export const LoginURI = 'https://api.zoning-info.com/oauth/token';
export const GraphQLAPI = 'https://api.zoning-info.com/graphql';
export const ClientID = '706acd37-bdcb-423a-b8c3-bd6c4e140488';
export const ClientSecret = 'zoning-info-react';

export const apiLoginId = '7WLt9Dkc4b';
export const environment = 'sandbox';
export const clientKey = '5dV978496fUeSK3WweqN3ehvbcFCatFA7rN2BVK5366bST2FFst2dSvzRXw9fvy8';
